<template>
  <div>
    <b-row>
      <b-col>
        <p class="label-color supplier-company-name m-0">
          {{ SUPPLIER_INFO.companyName }}
        </p>
        <p class="label-color custom-lable-text m-0">
          Địa chỉ: {{ SUPPLIER_INFO.address }}
        </p>
        <p class="label-color custom-lable-text m-0">
          MST: {{ SUPPLIER_INFO.taxCode }}
        </p>
      </b-col>
      <b-col></b-col>
      <b-col> </b-col>
    </b-row>
    <b-row class="mt-10">
      <div style="margin-left: 20px; margin-right: 20px; width: 100%">
        <h5
          class="label-color text-center font-size-print mb-2"
          style="font-size: 20px"
        >
          {{ printTitle }}
        </h5>
        <p class="text-center mb-2">
          <span class="custom-lable-text">Số: </span>
          <span class="font-weight-bold">{{ transaction.id }}</span>
        </p>
        <p class="text-center mb-2">
          <span class="font-weight-bold">Ngày: </span>
          <span class="font-weight-bold">{{ formattedDate }}</span>
        </p>
        <b-row class="mt-10" v-if="transactionType === 'OUT'">
          <b-col md="8">
            <h5 class="mb-2">THÔNG TIN NGƯỜI NHẬN</h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="8" v-if="transactionType === 'OUT'">
            <p>
              <span class="custom-lable-text">Họ và tên:</span>
              {{ transaction.customerName || contactName }}
            </p>
          </b-col>
          <b-col md="8" v-if="transactionType === 'IN'">
            <p>
              <span class="custom-lable-text">Họ và tên người nộp tiền:</span>
              {{ transaction.customerName || contactName }}
            </p>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="3">
            <p>
              <span class="custom-lable-text">SĐT:</span>
              {{ transaction.customerMobile }}
            </p>
          </b-col>
          <b-col md="9">
            <p>
              <span class="custom-lable-text">Địa chỉ:</span>
              {{ transaction.customerAddress }}
            </p>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <p>
              <span class="custom-lable-text">Trực thuộc công ty/Đơn vị:</span>
              {{ transaction.customerCompanyName }}
            </p>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            <p>
              <span class="custom-lable-text">Số tiền:</span>
              {{ convertPrice(transaction.amount) }}
            </p>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="8">
            <p>
              <span class="custom-lable-text">Bằng chữ</span>
              : {{ transaction.amountText }}
            </p>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="8">
            <p>
              <span class="custom-lable-text">Lý do chi: </span>
              {{ transaction.note }}
            </p>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="8">
            <p>
              <span class="custom-lable-text">Loại chứng từ: </span>
              {{ transaction.reconciliationDocTypeName }}
            </p>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="8">
            <p>
              <span class="custom-lable-text">ID chứng từ: </span>
              {{ transaction.reconciliationDocId }}
            </p>
          </b-col>
        </b-row>
        <b-row class="mt-5">
          <b-col class="text-center">
            <p class="mb-0">
              <span class="custom-lable-text">Người lập phiếu</span>
            </p>
            <p>(Ký, họ tên)</p>
          </b-col>
          <b-col>
            <p class="mb-0">
              <span class="custom-lable-text">Người nhận tiền</span>
            </p>
            <p>(Ký, họ tên)</p>
          </b-col>
          <b-col>
            <p class="mb-0">
              <span class="custom-lable-text">Thủ quỹ</span>
            </p>
            <p>(Ký, họ tên)</p>
          </b-col>
          <b-col
            ><p class="mb-0">
              <span class="custom-lable-text">Kế toán trưởng</span>
            </p>
            <p>(Ký, họ tên)</p>
          </b-col>
          <b-col
            ><p class="mb-0">
              <span class="custom-lable-text">Giám đốc</span>
            </p>
            <p>(Ký, họ tên)</p>
          </b-col>
        </b-row>
        <b-row class="mt-10 pt-10">
          <b-col md="8">
            <p class="text-left mb-2">
              <span class="custom-lable-text"
                >Đã nhận đủ số tiền (viết bằng chữ):
                {{ transaction.amountText }}</span
              >
            </p>
          </b-col>
        </b-row>
      </div>
    </b-row>
  </div>
</template>
<script>
import {
  convertPrice,
  formatDate,
  convertNumberToText,
  upperCaseFirstLetter,
} from '@/utils/common';
import { SUPPLIER_INFO } from '@/utils/constants';

export default {
  name: 'PrintTransaction',
  props: ['printData', 'transactionType'],
  watch: {
    printData: {
      handler(newPrintData) {
        this.transaction = newPrintData.transaction || {};
        if (this.transaction.amount) {
          const amountText = convertNumberToText(this.transaction.amount);
          this.transaction.amountText = upperCaseFirstLetter(amountText);
        }
      },
      deep: true,
      immediate: true,
    },
    transactionType: {
      handler(newTransactionType) {
        this.transactionType = newTransactionType;
        this.printTitle =
          this.transactionType === 'IN' ? 'PHIẾU THU' : 'PHIẾU CHI';
      },
      immediate: true,
    },
  },
  computed: {
    formattedDate() {
      if (!this.transaction.createdAt) return '.... tháng .... năm';
      try {
        const dateStr = this.transaction.createdAt;
        // Xử lý nhiều format khác nhau
        if (dateStr.includes('T') || dateStr.includes('-')) {
          const formatted = formatDate(dateStr, 'DD/MM/YYYY');
          const [day, month, year] = formatted.split('/');
          return `${day} tháng ${month} năm ${year}`;
        }
        if (dateStr.includes('/')) {
          const parts = dateStr.split(' ');
          const datePart = parts.length > 1 ? parts[1] : parts[0];
          const [day, month, year] = datePart.split('/');
          if (day && month && year) {
            return `${day} tháng ${month} năm ${year}`;
          }
        }
        return '.... tháng .... năm';
      } catch (error) {
        console.error('Error formatting date:', error);
        return '.... tháng .... năm';
      }
    },
  },
  methods: {
    convertPrice,
    formatDate,
    convertNumberToText,
    upperCaseFirstLetter,
  },
  data() {
    return {
      SUPPLIER_INFO,
      transaction: {},
      printTitle: '',
    };
  },
};
</script>
<style scoped>
.label-color {
  color: black;
  font-weight: 600;
}

.content-info {
  color: black;
  font-weight: 500;
}

.font-size-print {
  color: black;
  font-size: 13px;
}

.font-size-warranty {
  color: black;
  font-size: 13px;
}

.content-product {
  line-height: 1.375;
  white-space: pre-wrap;
  font-size: 13px;
  margin-top: 4px;
}

.font-size-gift {
  color: black;
  font-size: 12px;
}

.custom-lable-text {
  font-size: 13px;
  font-weight: 500 !important;
  color: black;
}
</style>
